import { Button } from "@/components/ui/button";
import { createAndAddTextToCanvas } from "../helpers/textHelpers";
import { Canvas } from "../types/canvasTypes";
import { DEFAULT_TEXT_OPTIONS } from "../constants/canvasConstants";
import { ImageIcon, LayoutTemplateIcon, SettingsIcon, TextIcon } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setCurrentInspectorState } from "@/store/templateEditor/templateEditorSlice";
import { UndoRedoToolbar } from "./UndoRedoToolbar";
import { Separator } from "@/components/ui/separator";

interface Props {
  canvas: Canvas;
}

export const CanvasBar: React.FC<Props> = ({ canvas }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onAddTextClick = () => {
    if (!canvas) return;
    createAndAddTextToCanvas(canvas, DEFAULT_TEXT_OPTIONS);
  };

  const onAddImageClick = async () => {
    if (!canvas) return;
    // const image = await loadImage(
    //   "https://static.scientificamerican.com/dam/m/4beab95014486f06/original/Tree-Swallow2.JPG?m=1714055470.635&w=600"
    // );
    // const imageOptions = calculateDefaultOptionsForImage(image, {
    //   width: 200,
    //   height: 200,
    // });
    // image.set(imageOptions);

    // initControls(image);

    // canvas.add(image);
    // canvas.setActiveObject(image);
    // canvas.requestRenderAll();
    dispatch(setCurrentInspectorState("media-library"));
  };

  const onTemplateSettingsClick = () => {
    dispatch(setCurrentInspectorState("projectSettings"));
  };

  const onShapesClick = () => {
    dispatch(setCurrentInspectorState("shapes"));
  };

  return (
    <div className="flex items-center justify-center gap-2 border-b h-[48px]">
      <UndoRedoToolbar canvas={canvas} />

      <Separator orientation="vertical" className="h-6" />

      <Tooltip>
        <TooltipTrigger>
          <Button onClick={onAddTextClick} variant="outline" size="sm" className="border-0">
            <TextIcon className="w-2 h-2" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>{t("template.addText")}</TooltipContent>
      </Tooltip>

      <Tooltip>
        <TooltipTrigger>
          <Button onClick={onAddImageClick} variant="outline" size="sm" className="border-0">
            <ImageIcon className="w-2 h-2" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>{t("template.addImage")}</TooltipContent>
      </Tooltip>

      <Tooltip>
        <TooltipTrigger>
          <Button onClick={onTemplateSettingsClick} variant="outline" size="sm" className="border-0">
            <SettingsIcon className="w-2 h-2" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>{t("template.templateSettings")}</TooltipContent>
      </Tooltip>

      <Tooltip>
        <TooltipTrigger>
          <Button onClick={onShapesClick} variant="outline" size="sm" className="border-0">
            <LayoutTemplateIcon className="w-2 h-2" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>{t("template.inspector.shapes")}</TooltipContent>
      </Tooltip>
    </div>
  );
};
